import React from 'react';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import ReadBarcode from 'library/readBarcode';
import scanIcon from 'images/barcode.png';
import { showError } from 'actions/CommonActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { editProductUPC } from 'actions/EntityActions';
import CustomButton from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import TextInput from 'screens/components/basic/TextInput';
import DialogConfirm from 'screens/components/basic/DialogConfirm';
import LOOKUP from 'constants/lookup';

class ProductUPCEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInput: false,
      upc: ""
    }
    this.barcode = new ReadBarcode();
  }

  componentDidMount() {
    window.addEventListener("keypress", this.barcodeListener);
    this.props.formInput(false, "UPCOnly");
  }

  componentWillUnmount() {
    window.removeEventListener("keypress", this.barcodeListener);
    this.props.clearFormInput(`editUPCNumber`);
  }

  barcodeListener = () => {
    this.barcode.listening(this.setUpc)
  }

  showInputText = () => {
    this.setState({ showInput: true });
    window.removeEventListener("keypress", this.barcodeListener);
  }

  setUpc = (upc) => {
    console.log(upc);
    this.setState({ upc });
  }

  changeUPC = (changeOldtoInvalid = false) => {
    let barcode = (this.props.editUPCNumber) ? this.props.editUPCNumber : this.state.upc;
    if (!barcode) {
      this.props.showError("Please Scan Or Input A valid UPC!");
    } else {
      let realUPC = "";
      let lotNumber = "";
      barcode = barcode.replace(/\(|\)/gi, "");
      // barcode validation
      if (!this.props.isMedical && this.props.isCannabis && !this.props.upcOnly) {
        if (barcode.length < 26 || barcode.length > 46) {
          this.props.showError("This product is set to Legal Barcode, please scan a correct barcode 2D fromat.");
          return;
        } else {
          let UPCIdentifier = barcode.substring(0, 2);
          let expirationDateIdentifier = barcode.substring(16, 18);
          let expirationDateValue = barcode.substring(18, 24);
          let lotNumberIdentifier = barcode.substring(24, 26);
          if (UPCIdentifier != "01" || (expirationDateIdentifier != "17" && expirationDateIdentifier != "13" && expirationDateIdentifier != "11") || lotNumberIdentifier != "10" || isNaN(parseInt(expirationDateValue))) {
            this.props.showError("Please Scan Or Input A Correct BarCode!");
            return;
          }
        }
      }

      //if it's cannabis grab the substring
      if (!this.props.isMedical && this.props.isCannabis && !this.props.upcOnly) {
        realUPC = parseInt(barcode.substring(2, 16)).toString();
        lotNumber = barcode.substring(26);
      } else {
        realUPC = barcode;
        lotNumber = "";
      }
      let model = {
        BranchId: this.props.branchId,
        ProductId: this.props.productId,
        UPC: realUPC,
        LotNumber: lotNumber,
        ChangeOldtoInvalid: changeOldtoInvalid,
        UPCOnly: this.props.upcOnly,
        UpdateFromCatalog: false
      };
      this.props.editUPC(model);
    }
  }

  clearExistUPC = () => {
    this.props.clearFormInput("editupcBarcodeExist");
    this.props.clearFormInput("editExistUPCProductName");
  }

  cancelChangeUPC = () => {
    this.clearExistUPC();
  }

  changeUPCandOverwrite = () => {
    this.clearExistUPC();
    this.changeUPC(true);
  }


  render() {
    let barcodeText = this.props.upcOnly ? "UPC" : "Barcode"
    return (

      <div>
        <div className="text-center">
          <div className="col-lg-6 col-xs-12"><ToggleInput className="UPCOnly" name={`UPCOnly`} label="UPC Only" /></div>
          <br></br>
          <h2 className="col-lg-12 pb-2">Scan {barcodeText}</h2>
          <div className="img_centered">
            <img src={scanIcon} />
          </div>
          <h3>{this.state.upc}</h3>
          {
            (!this.state.upc) ? <CustomButton type="FlatButtonPrimary" label={`Input ${barcodeText}`} secondary={false} onTouchTap={this.showInputText} /> : ''
          }
          {
            (this.state.showInput && !this.state.upc)
              ? <div className="centered pb-5">
                <TextInput
                  name={'editUPCNumber'}
                  hintText={`${barcodeText} Number`}
                  fullWidth={true}
                  className="input-center"
                  label={`${barcodeText} Number`}
                />
              </div> : ''
          }
        </div>

        <div style={{ marginTop: 12 }}>
          <Button
            className="pull-right"
            variant="contained"
            onClick={() => this.changeUPC()}
          >
            Confirm
          </Button>

          <Button
            className="pull-right"
            variant="text"
            onClick={this.props.cancel}
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
        </div>
        <DialogConfirm title={LOOKUP.pos.confirmOverwriteUPCDialog.title} isOpen={this.props.editupcBarcodeExist}
          message={LOOKUP.pos.confirmOverwriteUPCDialog.message + this.props.editExistUPCProductName}
          onConfirm={() => this.changeUPCandOverwrite()}
          onCancel={() => this.cancelChangeUPC()}
        />
      </div>
    );
  }
}

function mapStatetoProps(state) {
  return {
    branchId: state.common.branchId,
    isMedical: state.common.applicationSettings.isMedical,
    isCannabis: state.form.ProductSaveisCannabis,
    editUPCNumber: state.form.editUPCNumber,
    editupcBarcodeExist: state.form.editupcBarcodeExist == undefined || state.form.editupcBarcodeExist == null ? false : state.form.editupcBarcodeExist,
    editExistUPCProductName: state.form.editExistUPCProductName || null,
    upcOnly: state.form.UPCOnly
  };
}

function mapDispatchToProps(dispatch) {
  return {
    formInput: (value, name) => dispatch(formInput(value, name)),
    showError: (message) => dispatch(showError(message)),
    editUPC: (model) => dispatch(editProductUPC(model)),
    clearFormInput: (name) => dispatch(clearFormInput(name))
  };
}


export default connect(mapStatetoProps, mapDispatchToProps)(ProductUPCEdit);